import React from "react";
import Layout from "components/Layout/Layout";
import Wrapper from "components/ReusableComponents/Wrapper/Wrapper";

function LegalAdviceDetails(props) {
  const data = props.pageContext.data;
  return (
    <Layout>
      <Wrapper>
        <h1 className="text-4xl text-black text-center xs:font-cairo font-semibold pb-3">
          {data.title}
        </h1>
        <div className="border border-greyMid h-screen overflow-scroll my-7 px-10 py-7">
          <p className="text-2xl text-black xs:font-cairo pb-8">Description</p>
          <div
            className="text-lg text-black xs:font-cairo"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
      </Wrapper>
    </Layout>
  );
}
export default LegalAdviceDetails;
